import clsx from "clsx";
import React, { useId } from "react";

import { RequiredAsterisk } from "../required-asterisk";
import { FormFieldIdProvider, formFieldLabelId } from "./form-field-id-context";
import styles from "./form-row.module.css";

export function FormRow({
  label,
  hint,
  data,
  mandatory,
  maxWidth,
  kind = "field",
}: {
  label: React.ReactNode;
  hint?: React.ReactNode;
  data: React.ReactNode;
  mandatory?: boolean;
  maxWidth?: boolean;
  /**
   * `field`: the label names the form field inside the row. `info`: the row
   * shows something, such as text or buttons, so the label names its content
   * as a whole.
   */
  kind?: "field" | "info";
}) {
  const fieldId = useId();
  const labelId = formFieldLabelId(fieldId);

  return (
    <>
      <div className={styles.leftColumn}>
        <div>
          <label id={labelId} htmlFor={kind === "field" ? fieldId : undefined}>
            {label}: {mandatory && <RequiredAsterisk />}
          </label>
          {hint && <div className="font-normal">{hint}</div>}
        </div>
      </div>
      <FormFieldIdProvider value={fieldId}>
        <div
          role={kind === "info" ? "group" : undefined}
          aria-labelledby={kind === "info" ? labelId : undefined}
          className={clsx(
            styles.rightColumn,
            (maxWidth ?? true) && styles.columnMaxWidth,
          )}
        >
          {data}
        </div>
      </FormFieldIdProvider>
      <div className={styles.spacer} />
    </>
  );
}
